"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
const useCanSSR = () => {
  // we always start off in "SSR mode", to ensure our initial browser render
  // matches the SSR render
  const [isSsr, setIsSsr] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    // `useEffect` never runs on the server, so we must be on the client if
    // we hit this block
    setIsSsr(false);
  }, []);
  return isSsr;
};
var _default = exports.default = useCanSSR;